import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseItem from "../BaseItem";
import CartIcon from "@dcl/icons/esm/ui/cart";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { AuthState, getRehydratableName, getClassNameFactory } from "../../../../utilities";

var Cart = /*#__PURE__*/function (_Component) {
  _inherits(Cart, _Component);

  var _super = _createSuper(Cart);

  function Cart(props) {
    var _this;

    _classCallCheck(this, Cart);

    _this = _super.call(this, props);
    _this.loginManagerChange = _this.loginManagerChange.bind(_assertThisInitialized(_this));

    if (_this.props.loginManager) {
      _this.props.loginManager.onChange(_this.loginManagerChange);
    }

    return _this;
  }

  _createClass(Cart, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.loginManager) {
        this.props.loginManager.offChange(this.loginManagerChange);
      }
    }
  }, {
    key: "loginManagerChange",
    value: function loginManagerChange() {
      if (this.props.loginManager) {
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var getClassName = getClassNameFactory("GlobalHeaderCart");

      var Wrapper = function Wrapper(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/React.createElement("li", {
          className: getClassName(),
          "data-rehydratable": getRehydratableName(Cart.displayName),
          "data-label": _this2.props.label
        }, children);
      };

      if (!this.props.loginManager) {
        return /*#__PURE__*/React.createElement(Wrapper, null);
      }

      var label;

      if (this.props.loginManager.authState === AuthState.UNKNOWN) {
        label = this.props.label;
      } else {
        label = "".concat(this.props.label, " (").concat(this.props.loginManager.itemsInCart, ")");
      }

      return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(BaseItem, _extends({}, this.props, {
        longLabel: label,
        label: "",
        icon: /*#__PURE__*/React.createElement(CartIcon, null),
        href: this.props.loginManager.cartUrl
      })));
    }
  }]);

  return Cart;
}(Component);

_defineProperty(Cart, "displayName", "GlobalHeader.Cart");

_defineProperty(Cart, "propTypes", {
  /**
   * The label to show on this Cart.
   */
  label: PropTypes.string.isRequired,

  /**
   * LoginManager instance, required at rehydration.
   */
  loginManager: PropTypes.object
});

export default Cart;